module.exports = __webpack_public_path__ + "img/WeChat_ma.5a1f340e.png";